module.exports = __webpack_public_path__ + "static/media/excel.4cf20638.webp";